import { provideHttpClient, withFetch, withInterceptors, } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection
} from '@angular/core';
import { DateFnsAdapter, provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { provideClientHydration, withEventReplay, withI18nSupport, withNoIncrementalHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { PreloadAllModules, provideRouter, withComponentInputBinding, withInMemoryScrolling, withPreloading, } from '@angular/router';
import { MAT_TOOLTIP_SCROLL_STRATEGY } from '@angular/material/tooltip';
import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { DATE_BG_FORMATS } from '@zhik/core/constants/date-time';
import { dskHomeHttpInterceptor } from '@zhik/core/interceptors/dskhome-http';
import { serverCredentialsInterceptor } from '@zhik/core/interceptors/server-credentials';
import { serverErrorLoggerInterceptor } from '@zhik/core/interceptors/server-error-logger';
import { MortgageConsultationContextService } from '@zhik/core/services/mortgage-consultation-context';
import { UtmTrackingService } from '@zhik/core/services/utm-tracking';
import { appRoutes } from './app.routes';
import { appInitializerFactory } from './app.initializer';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top'
      }),
      withPreloading(PreloadAllModules),
      withComponentInputBinding()
    ),
    provideHttpClient(withFetch(), withInterceptors([serverErrorLoggerInterceptor, dskHomeHttpInterceptor, serverCredentialsInterceptor])),
    provideClientHydration(withEventReplay(), withI18nSupport(), withNoIncrementalHydration()),
    provideAppInitializer(appInitializerFactory),
    provideAppInitializer(() => inject(MortgageConsultationContextService).initialize()),
    provideAppInitializer(() => inject(UtmTrackingService).initialize()),
    provideAnimationsAsync(),
    provideAnimations(),
    {
      provide: MAT_TOOLTIP_SCROLL_STRATEGY,
      useFactory: (scrollStrategyOptions: ScrollStrategyOptions) => scrollStrategyOptions.close,
      deps: [ScrollStrategyOptions]
    },
    provideDateFnsAdapter(DATE_BG_FORMATS),
    { provide: DateAdapter, useClass: DateFnsAdapter, deps: [MAT_DATE_LOCALE] }
  ],
};
